const modelName = 'Orderwise Products';
const modelNameSingular = 'Orderwise Product';
const endpoint = '/orderwise_products';

const setup = {
  title: modelName,
  singular: modelNameSingular,
  model: modelName.replace(/\s+/g, '-').toLowerCase(),
  canDelete: true,
  canAddNew: true,
  canSearch: true,
  endpoint,
  accessor: 'id',
};

export default setup;
